export const environment = {
    ticketAPI: 'https://ticketingtool-dev.teamleaseregtech.com/api',
    liveURL: 'https://ticketingtool.teamleaseregtech.com/api'
};